module.exports = __webpack_public_path__ + "static/media/tanqueSPTBvert.23f0c4f2.jpg";